// extracted by mini-css-extract-plugin
module.exports = {"tabLines":"FLuRKSqE","entityPriceWrapperUniversal":"KYs4kzUz","emptyContainer":"HR3IZpjH","emptyWrapper":"H963uQ7w","emptyTitle":"tu6jeMOZ","emptyImage":"Qu4Ede6J"};